export * from './UIGameEndHeader.tsx';
